import * as React from 'react';

import { Text } from '../../Text';
import { IBargainTermsForDesktopSchema } from '../../../repositories/favorites/entities/favorite_entity_for_desktop/BargainTermsForDesktopSchema';

export interface IBargainTermsInfoProps {
  bargainTerms: IBargainTermsForDesktopSchema;
  isNewbuilding: boolean;
}

export function BargainTermsInfo({ bargainTerms, isNewbuilding }: IBargainTermsInfoProps) {
  const { clientCommissionText, priceText, utilitiesText, depositText } = bargainTerms;

  if (isNewbuilding) {
    return (
      <>
        {priceText && (
          <div>
            <Text bold={true}>{priceText}</Text>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {priceText && (
        <div>
          <Text bold={true}>{priceText}</Text>
        </div>
      )}
      {depositText && (
        <div>
          <Text textSize="small" color="gray">
            {depositText}
          </Text>
        </div>
      )}
      {utilitiesText && (
        <div>
          <Text textSize="small" color="gray">
            {utilitiesText}
          </Text>
        </div>
      )}
      {clientCommissionText && (
        <div>
          <Text textSize="small" color="gray">
            {clientCommissionText}
          </Text>
        </div>
      )}
    </>
  );
}
